import EventEmitter from 'eventemitter3';

function Holder(renderTools, parentContainer, container, transform, updateSceneObjects, sceneObjects, context) {
  this.transform = transform;
  this.parentContainer = parentContainer;
  this.container = container;
  this.renderTools = renderTools;
  this.alpha = 1;
  this.children = {};
  this.eeuData = {};
  this.oldZindex = -999999999999;
  this.entered = false;
  this.isInvisible  = false;
  this.localContainer = new PIXI.Container();
  this._events = new EventEmitter();
  this.enabledInteractive = false;
  this.updateSceneObjects = updateSceneObjects;
  this.context = context;
}
Holder.prototype.setInvisible = function (invisible) {
  this.isInvisible = invisible;
  this.update();
}
Holder.prototype.getGlobalPoint = function (point) {
  //return this.localContainer.worldTransform.apply(point);
  const p = this.localContainer.worldTransform.apply(point);
  return p;
}

Holder.prototype.getLocalPoint = function (point) {
  return this.localContainer.worldTransform.applyInverse(point);
}

Holder.prototype.getLocalPointInParent = function (point) {
  return this.parentContainer.getWorldTransform().applyInverse(point);
}
Holder.prototype.getGlobalPointInParent = function (point) {
  return this.parentContainer.getWorldTransform().apply(point);
}

Holder.prototype.getGlobalBounds = function () {
  const scalex = 1;
  const scaley = 1;

  const p1 = this.localContainer.worldTransform.apply({x:-scalex/2,y:-scaley/2});
  const p2 = this.localContainer.worldTransform.apply({x:scalex/2,y:-scaley/2});
  const p3 = this.localContainer.worldTransform.apply({x:scalex/2,y:scaley/2});
  const p4 = this.localContainer.worldTransform.apply({x:-scalex/2,y:scaley/2});

  return {
    p1,
    p2,
    p3,
    p4
  }

}
Holder.prototype.getScaleThingy = function (type) {
  if (type === 'local') {
    return this.transform.transform.localScale;
  } else {
    if (!this.parent) {
      return {
        x:this.transform.transform.scale.x,
        y:this.transform.transform.scale.y
      }
    }
    const parentScale = this.parent.getScaleThingy();
    return {
      x:this.transform.transform.scale.x * parentScale.x,
      y:this.transform.transform.scale.y * parentScale.y
    }
  }
}
Holder.prototype.enter = function() {
  this.container.addChild(this.localContainer);

  this.setZindex();
  this.parentContainer.addChild(this.container);

}

Holder.prototype.setDisabled = function (disabled) {
  if (disabled) {
    this.overrideAlpha = 0.6;
  } else {
    delete this.overrideAlpha;
  }
}

Holder.prototype.setZindex = function () {
  let zindex = parseInt(this.transform.transform.zIndex);
  let layer = this.context.overrideLayer || this.transform.transform.layer;
  if (this.oldZindex !== zindex) {
    zindex = this.renderTools.setZIndex(this.localContainer, layer, zindex);
    this.oldZindex = zindex;
    if (!this.context.insideToy) {
      this.localContainer.__zindex = zindex;
    }
  }
}



Holder.prototype.update = function() {

  if (!this.container) {
    console.error('lol');
    return;
  }

  this.setZindex();
  this.container.x = this.renderTools.worldToScreen_x(this.transform.transform.pos.x);
  this.container.y = this.renderTools.worldToScreen_y(this.transform.transform.pos.y);

  // TODO: but a why
  //this.container.containerUpdateTransform();

  this.container.rotation = this.transform.transform.rotation;
  this.container.scale.x = this.transform.transform.scale.x;
  this.container.scale.y = this.transform.transform.scale.y;
  if (typeof(this.transform.transform.alpha) === 'undefined') {
    this.container.alpha = 1;
  } else {
    this.container.alpha = Math.max(this.transform.transform.alpha,0.2);
  }

  if (typeof(this.overrideAlpha) !== 'undefined') {
    this.container.alpha = this.overrideAlpha;
  }
  this.localContainer.x = 0;
  this.localContainer.y = 0;
  this.localContainer.scale.x = this.transform.transform.localScale.x;
  this.localContainer.scale.y = this.transform.transform.localScale.y;
  this.localContainer.rotation = this.transform.transform.localRotation;

  if (this.enabledInteractive) {
    this.enableInteractive();
  }

  if (this.transform.transform.anchor) {
    const anchor = this.transform.transform.anchor;
    this.container.pivot.x = (0.5 - anchor.x) * this.container.width / this.container.scale.x;
    this.container.pivot.y = (0.5 - anchor.y) * this.container.height / this.container.scale.y;
  }

  // TODO: why??
  if (this.container.cacheAsBitmap) {
    this.container.containerUpdateTransform();
  }
  if (this.localContainer.cacheAsBitmap) {
    this.container.containerUpdateTransform();
    this.localContainer.containerUpdateTransform();
  }

}

Holder.prototype.exit = function() {
  if (this.localTransform) {
    this.localTransform.destroy({
      children:true,
      texture:false
    });
  }
  if (this.container) {
    this.container.destroy({
      children:true,
      texture:false
    })
  }
  //this.draw.exit();
  Object.values(this.children).forEach( (child) => {
    child.exit();
  });
  this.parentContainer.removeChild(this.localContainer);
  this.parentContainer.removeChild(this.container);
  if (this.renderTools.removeLayer) {
    this.renderTools.removeLayer(this.container)
  }
  //if (this.renderTools.d3Objects.app.stage) {
    //this.renderTools.d3Objects.app.stage.removeChild(this.localContainerLayer);
  //}
  //

}

Holder.prototype.enableInteractive = function () {
  if (this.context.disableInteraction) {
    return;
  }
  if (!this.enabledInteractive) {
    //this.localContainer.on('pointertap', (e) => {
    this.localContainer.on('hammertap', (e) => {
      this._events.emit("hammertap");
    });
    this.localContainer.on('hammerpress', (e) => {
      this._events.emit("hammerpress");
    });
    this.localContainer.on('hammerpressup', (e) => {
      this._events.emit("hammerpressup");
    });
    this.localContainer.on('hammershortpress', (e) => {
      this._events.emit("hammershortpress");
    });
    this.localContainer.on('hammershortpressup', (e) => {
      this._events.emit("hammershortpressup");
    });

    this.localContainer.on('hammerpanstart', (e) => {
      this._events.emit("hammerpanstart", e);
    });
    this.localContainer.on('hammerpanmove', (e) => {
      this._events.emit("hammerpanmove", e);
    });
    this.localContainer.on('hammerpanend', (e) => {
      this._events.emit("hammerpanend", e);
    });
    //this.localContainer._events = events;
    //this.localContainer.on('hammertap', (e) => {
      //this._events.emit("pointerdown");
    //});
    /*
    this.localContainer.on('pointerup', (e) => {
      this._events.emit("pointerup");
    });
    */
  }
  this.enabledInteractive = true;
  if (this.isInvisible) {
    this.container.alpha = 0
    this.localContainer.interactive = false;
  } else {
    this.localContainer.interactive = true;
  }

  this.localContainer.buttonMode = true;
}

Holder.prototype.alignCenter = function () {
  this.transform.transform.pos.y = 0;
}
Holder.prototype.alignTop = function () {
  const absolutey = this.getHeight();
  this.transform.transform.pos.y = -16/2 + absolutey / 2;;
}
Holder.prototype.alignBottom = function () {
  const absolutey = this.getHeight();
  this.transform.transform.pos.y = 16/2 - absolutey / 2;
}
Holder.prototype.alignRight = function () {
  const absolutex = this.getWidth();
  this.transform.transform.pos.x = 9/2 - absolutex / 2;
}
Holder.prototype.alignLeft = function () {
  const absolutex = this.getWidth();
  this.transform.transform.pos.x = -9/2 + absolutex / 2;
}
Holder.prototype.alignMiddle = function () {
  this.transform.transform.pos.x = 0;
}

Holder.prototype.getWidth = function () {
  return this.renderTools.getWorldSize(this.container).width;
}
Holder.prototype.getHeight = function () {
  return this.renderTools.getWorldSize(this.container).height;
}

Holder.prototype.scaleCover = function () {
  const absolutex = this.getWidth();
  const absolutey = this.getHeight();
  console.log('width,height', absolutex, absolutey);

  const ratio = absolutex/absolutey;
  
  const localScale = this.transform.transform.localScale;
  if (typeof(this.__originalLocalScale) === 'undefined') {
    this.__originalLocalScale = {
      x:localScale.x,
      y:localScale.y,
    }
  }

  console.log('ratio', ratio);
  const canvasSize = this.renderTools.getCanvasSize();
  if (ratio >= 1) {
    const needed = canvasSize.rows / absolutey;
    localScale.x = localScale.x * needed;
    localScale.y = localScale.y * needed;
  } else {
    const needed = canvasSize.cols / absolutex;
    localScale.y = localScale.y * needed;
    localScale.x = localScale.x * needed;
  }

  //this.transform.transform.localScale.x /= this.transform.transform.scale.x;
  //this.transform.transform.localScale.y /= this.transform.transform.scale.y;
  this.renderTools.executeAutoScaleEvent(this.transform, this);
}

Holder.prototype.scaleOriginal = function () {
  if (typeof(this.__originalLocalScale) === 'undefined') {
    return;
  }
  const localScale = this.transform.transform.localScale;
  localScale.x = this.__originalLocalScale.x;
  localScale.y = this.__originalLocalScale.y;
  this.renderTools.executeAutoScaleEvent(this.transform, this);
}

Holder.prototype.scaleContain = function () {
  const absolutex = this.getWidth();
  const absolutey = this.getHeight();

  const ratio = absolutex/absolutey;
  
  const localScale = this.transform.transform.localScale;
  if (typeof(this.__originalLocalScale) === 'undefined') {
    this.__originalLocalScale = {
      x:localScale.x,
      y:localScale.y,
    }
  }

  const canvasSize = this.renderTools.getCanvasSize();
  if (ratio >= 1) {
    const needed = canvasSize.cols / absolutex;
    localScale.x = localScale.x * needed;
    localScale.y = localScale.y * needed;
  } else {
    const needed = canvasSize.rows / absolutey;
    localScale.y = localScale.y * needed;
    localScale.x = localScale.x * needed;
  }

  //this.transform.transform.localScale.x /= this.transform.transform.scale.x;
  //this.transform.transform.localScale.y /= this.transform.transform.scale.y;
  console.log('auto scaling');
  this.renderTools.executeAutoScaleEvent(this.transform, this);
}

export default Holder;
